<kendo-dialog-titlebar (close)="onClose()">
  <div style="font-size: 18px; line-height: 1.3em;">
    {{this.isEdit ? 'Edit Klant' : 'Nieuwe Klant'}}
  </div>
</kendo-dialog-titlebar>

<form #form="ngForm">
<div>
  <div class="grid">
    @if (!this.isEdit) {
    <kendo-label class="label start" text="Dealer" [for]="dealers">
    </kendo-label>
    <kendo-combobox #dealers [data]="filteredDealers" [filterable]="true" [valueField]="'INDEX'" [textField]="'NAAM'"
      class="one-col" [(value)]="this.selectedDealer" (selectionChange)="this.dealerChanged($event)"
      (filterChange)="this.handleDealerFilter($event)"></kendo-combobox>

    }
    <kendo-label text="Klant No" class="label start">
    </kendo-label>
    <span [style]="{alignSelf: 'left'}" class="full">{{this.klantNo}}</span>


      <kendo-label text="Naam*" class="label" [for]="voornaam"  >
      </kendo-label>
      <kendo-textbox #voornaam="ngModel" name="voornaam" [(ngModel)]="this.kopInfo!.VOORNAAM!" required />
      
      <kendo-label text="Achternaam" class="label" [for]="achternaam">
      </kendo-label>
      <kendo-textbox #achternaam [(value)]="this.kopInfo!.ACHTERNAAM!"  />

      <kendo-label text="Adres" class="label" [for]="p_adres">
      </kendo-label>
      <kendo-textbox #p_adres [(value)]="this.kopInfo!.P_ADRES!"  />

      <kendo-label text="Postcode" class="label" [for]="p_postcode">
      </kendo-label>
      <kendo-textbox #p_postcode [(value)]="this.kopInfo!.P_POSTCODE!"  />

      <kendo-label text="Plaats" class="label" [for]="p_plaats">
      </kendo-label>
      <kendo-textbox #p_plaats [(value)]="this.kopInfo!.P_PLAATS!"  />

      <kendo-label text="Land*" class="label" [for]="p_land">
      </kendo-label>
      <kendo-textbox #p_land="ngModel" name="p_land" [(ngModel)]="this.kopInfo!.P_LAND!" required />

      <kendo-label text="Telefoon" class="label" [for]="telefoon">
      </kendo-label>
      <kendo-textbox #telefoon [(value)]="this.kopInfo!.TELEFOON!"  />

      <!-- <kendo-label text="Fax" class="label" [for]="fax">
      </kendo-label>
      <kendo-textbox #fax [(value)]="this.kopInfo!.FAX!"  /> -->

      <kendo-label text="Email" class="label" [for]="email1">
      </kendo-label>
      <kendo-textbox #email1 [(value)]="this.kopInfo!.EMAIL1!"  />

      <kendo-label text="Adres bedrijf*" class="label" [for]="b_adres">
      </kendo-label>
      <kendo-textbox #b_adres="ngModel" name="b_adres" [(ngModel)]="this.kopInfo!.B_ADRES!" required />

      <kendo-label text="Postcode bedrijf" class="label" [for]="b_postcode">
      </kendo-label>
      <kendo-textbox #b_postcode [(value)]="this.kopInfo!.B_POSTCODE!"  />

      <kendo-label text="Plaats bedrijf*" class="label" [for]="b_plaats">
      </kendo-label>
      <kendo-textbox #b_plaats="ngModel" name="b_plaats" [(ngModel)]="this.kopInfo!.B_PLAATS!" required />

      <kendo-label text="Type computer" class="label" [for]="typComputer">
      </kendo-label>
      <kendo-dropdownlist #typComputer [data]="systemTypes" [(value)]="this.kopInfo!.TYP_COMPUT"
        ></kendo-dropdownlist>
  <!-- 
      <kendo-label text="Type hoofdboard" class="label" [for]="typComputer">
      </kendo-label>
      <kendo-dropdownlist #typComputer [data]="memoryTypes" [(value)]="this.kopInfo!.TYP_HOOFDB"
        ></kendo-dropdownlist> -->

      <kendo-label text="Diversen" class="label start" [for]="diversen">

      </kendo-label>
      <kendo-textarea #diversen [(value)]="this.kopInfo!.DIVERSEN!" class="full"
        [rows]="8"></kendo-textarea>

  </div>
  <div class="k-form-error"
    *ngIf="voornaam.invalid && (voornaam.dirty || voornaam.touched)">
    Naam is verplicht.
  </div>
    <div class="k-form-error"
    *ngIf="p_land.invalid && (p_land.dirty || p_land.touched)">
    Land is verplicht.
  </div>
    <div class="k-form-error"
    *ngIf="b_adres.invalid && (b_adres.dirty || b_adres.touched)">
    Bedrijfsadres is verplicht.
  </div>
    <div class="k-form-error"
    *ngIf="b_plaats.invalid && (b_plaats.dirty || b_plaats.touched)">
    Bedrijfsplaats is verplicht.
  </div>
</div>

<kendo-dialog-actions>
  <button kendoButton (click)="onClose()">Cancel</button>
  <button kendoButton (click)="onConfirmAction()" themeColor="primary" (disabled)="form.invalid">
    Submit
  </button>
</kendo-dialog-actions>
</form>  

